//
//
//
//
//
//
//
//
//
//

export default {
	name: "donut-chart",
	props: ["data"],
	data: () => ({
		currenciesColors: {
			BTC: "#f89c2d",
			ETH: "#818283",
			XRP: "#00a3de",
			USDT: "#50ae94",
			BCH: "#f08c18",
			BSV: "#eab300",
			LTC: "#345d9d",
			EOS: "#c4c4c5",
			BNB: "#f2ba2f",
			ETC: "#03cc56",
		},
	}),
	computed: {
		colors() {
			return this.labels.map((el) => this.currenciesColors[el]);
		},
		labels() {
			return Object.keys(this.data).map((el) => el.toUpperCase());
		},
		chartData() {
			return Object.values(this.data).map((el) => parseFloat(el.toFixed(2)));
		},

		chartOptions() {
			return {
				chart: {
					width: "100%",
					type: "donut",
				},
				dataLabels: {
					enabled: false,
				},
				fill: {
					type: "gradient",
					gradient: {
						shadeIntensity: 10,
						opacityFrom: 0.1,
						opacityTo: 1,
						stops: [20, 50, 90],
					},
				},
				colors: this.colors,
				labels: this.labels,
				chart: {
					// offsetX: 120,
				},

				legend: {
					position: "bottom",
					// verticalAlign: "top",
					containerMargin: {
						// left: 135,
						// right: 60,
					},
					show: true,
					fontSize: "13px",
					
					// height: 150,
					labels: {
						useSeriesColors: true,
					},
					itemMargin: {
						vertical: 1,
					},
					formatter: function(val, opts) {
						return val + ": " + opts.w.globals.series[opts.seriesIndex] + "%";
					},
				},
			};
		},
	},
};
